import React from 'react';
import { Link } from "react-router-dom";
import AppBar from '@material-ui/core/AppBar';
import {Toolbar, Typography, Grid, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import FacebookIcon from '@material-ui/icons/Facebook';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import TwitterIcon from '@material-ui/icons/Twitter';
import classNames from 'classnames';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

const useStyles = makeStyles((theme) => ({
    root: {
        minWidth: 275,
        minHeight: 200,
    },

    title: {
        fontSize: 14,
    },

    gridContainerTop: {
        justifyContent: 'space-between', 
        alignItems: 'center',
    },

    gridContainerBottom: {
        borderTop: '1px solid #C4C4C4'
    },

    gridItemTop: {
        padding: theme.spacing(4),
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(1)
        }
    },

    gridItemSocials: {
        borderLeft: '1px solid #C4C4C4',
        [theme.breakpoints.down('sm')]: {
            borderLeft: 'none',
        }
    },

    socialMediaIcons: {
        margin: '10px',
        color: 'white',
        cursor: 'pointer',
        '&:hover': {
            background: '#15616d',
            color: 'white',
        }
    },

    gridItemBottom: {
        padding: theme.spacing(2),
        paddingLeft: theme.spacing(4),
        [theme.breakpoints.down('sm')]: {
            margin: 'auto',
            // padding: theme.spacing(2),
        }
    },

    gridItemBackToTop: {
        [theme.breakpoints.down('xs')]: {
            display: 'none'
        }
    },

    backToTopButton: {
        background: '#ff7d00',
        color: 'white',
        marginRight: '20px',
        borderRadius: "50%",
        height: '62px',
        width: '32px',
        '&:hover': {
            background: '#15616d',
        },
        [theme.breakpoints.down('xs')]: {
            display: 'none'
        }
    },

    impressumTypo: {
        cursor: 'pointer'
    }

}));


function Footer() {
    const classes = useStyles();

    return (
        <>        
            <AppBar position="static" color="primary" style={{background: '#001524'}}>
                <Grid container className={classes.gridContainerTop}>
                    <Grid item className={classes.gridItemTop}>
                        <Typography>Transporex Logo</Typography>
                    </Grid>
                    <Grid item className={classNames(classes.gridItemTop, classes.gridItemSocials)}>
                        <FacebookIcon className={classes.socialMediaIcons}/>
                        <LinkedInIcon className={classes.socialMediaIcons}/>
                        <TwitterIcon className={classes.socialMediaIcons}/>
                    </Grid>
                </Grid>

                <Grid container className={classNames(classes.gridContainerTop, classes.gridContainerBottom)} >
                    <Grid item className={classes.gridItemBottom}>
                        <Typography variant="body1" color="inherit" className={classes.impressumTypo}>Impressum<span style={{marginLeft: '20px', textAlign: 'center'}} className={classes.impressumTypo}>Terms of Services</span></Typography>
                    </Grid>
                    <Grid item className={classes.gridItemBottom} >
                        <Typography style={{textAlign: 'center'}} variant="body1" color="inherit">© {new Date().getFullYear()} Transporex GmbH - All Rights Reserved</Typography>
                    </Grid>
                    <Grid item className={classNames(classes.gridItemBottom, classes.gridItemBackToTop)}>
                        <Button variant="contained" className={classes.backToTopButton}><a href=''><KeyboardArrowUpIcon style={{color: 'white'}} fontSize='large'/></a></Button>
                    </Grid>
                </Grid>
            </AppBar> 
        </>
    )
}

export default Footer
